import React from 'react'

const ClockIcon = () => {
	return (
		<svg width={42} height={42} viewBox='0 0 42 42' fill='none' xmlns='http://www.w3.org/2000/svg'>
			<circle cx={21} cy={21} r={20} stroke='currentColor' strokeWidth={2} />
			<path d='M22.5 6.5V23l-9 7.5' stroke='currentColor' strokeWidth={2} />
		</svg>
	)
}

export default ClockIcon
